// extracted by mini-css-extract-plugin
export var item = "styles-module__item___PiDt8";